/**
 * Sidebar Header Component
 * Logo and brand name section
 */

import { useTranslation } from '@ufc/core'
import { cn } from '@ufc/uikit'
import type { SidebarHeaderProps } from '../types'

// ============================================
// Helper Functions
// ============================================

function getContainerStyles(collapsed: boolean): string {
  return cn(
    'border-b border-border/50 transition-[padding,gap] duration-300',
    collapsed ? 'p-4' : 'p-6'
  )
}

function getLogoContainerStyles(collapsed: boolean): string {
  return cn('flex items-center', collapsed ? 'justify-center' : 'gap-4')
}

function getLogoStyles(collapsed: boolean): string {
  return cn(
    'flex items-center justify-center transition-[width,height] duration-300',
    collapsed ? 'w-10 h-10' : 'w-12 h-12'
  )
}

// ============================================
// Component
// ============================================

export function SidebarHeader({ collapsed }: SidebarHeaderProps) {
  const { t } = useTranslation()

  return (
    <div className={getContainerStyles(collapsed)}>
      <div className={getLogoContainerStyles(collapsed)}>
        <div className={getLogoStyles(collapsed)}>
          <img
            src="/ufc-logo.png"
            alt="United Feed"
            className="w-full h-full object-contain"
          />
        </div>
        {!collapsed && (
          <div className="overflow-hidden">
            <h1 className="font-bold text-foreground text-lg tracking-tight whitespace-nowrap">
              United Feed
            </h1>
            <p className="text-xs text-muted-foreground font-medium whitespace-nowrap">
              {t('sidebar.portal')}
            </p>
          </div>
        )}
      </div>
    </div>
  )
}
